function getLocalFileTypesAccepted(accept) {
	let fileTypesAccepted = ''
	if (accept.includes('image')) {
		//Changing filetypes to only extensions so it works with Firefox
		fileTypesAccepted += '.png, .jpg, .bmp, .gif, .jpeg, .pdf'
		//fileTypesAccepted += 'image/x-png, image/jpg, image/jpeg, image/pjpeg, image/png, image/gif, image/bmp'
	}
	if (accept.includes('image-nopdf')) {
		fileTypesAccepted += '.png, .jpg, .bmp, .gif, .jpeg'
	}
	if (accept.includes('audio')) {
		fileTypesAccepted += ', .mp3, .ogg, .m4a, .wav, .aiff, .aif, .ac3, .aac, .wma'
	}
	if (accept.includes('video')) {
		fileTypesAccepted += ', .mpg, .mpeg, .mp4, .flv, .mov, .avi, .mpeg-1, .mpeg-2, .qt, .m4v, .wmv, .3gp, .asf, .ogv, .3gpp, .webm'
	}
	if (accept.includes('pdf')) {
		fileTypesAccepted += ', application/pdf, application/octet-stream'
	}
	if (accept.includes('ppt')) {
		fileTypesAccepted += ', application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation'
	}
	if (accept.includes('zip')) {
		fileTypesAccepted += ', application/zip, application/x-zip, application/x-zip-compressed, application/octet-stream, application/x-compress, application/x-compressed, multipart/x-zip'
	}
	if (accept.includes('gif')) {
		fileTypesAccepted += ', image/gif'
	}
	return fileTypesAccepted
}

function getDriveFileTypesAccepted(accept) {
	const fileTypesAccepted = []
	if (accept.includes('image')) {
		fileTypesAccepted.push('image/x-png', 'image/jpg', 'image/jpeg', 'image/pjpeg', 'image/png', 'image/gif', 'image/bmp', 'application/vnd.google-apps.photo', 'application/pdf', 'application/octet-stream')
	}
	if (accept.includes('audio')) {
		fileTypesAccepted.push('audio/ogg', 'audio/mp3', 'audio/m4a', 'audio/wav', 'audio/aiff', 'audio/aif', 'audio/ac3', 'audio/aac', 'audio/wma', 'audio/mpeg')
	}
	if (accept.includes('video')) {
		fileTypesAccepted.push('video/mpg', 'video/mpeg', 'video/mp4', 'video/ogv', 'video/flv', 'video/mov', 'video/quicktime', 'video/m4v', 'video/avi', 'video/3gpp', 'video/3gp', 'video/asf', 'video/x-ms-asf', 'video/x-msvideo', 'video/x-flv', 'application/vnd.google-apps.video', 'video/webm')
	}
	if (accept.includes('pdf')) {
		fileTypesAccepted.push('application/pdf', 'application/octet-stream')
	}
	if (accept.includes('ppt')) {
		fileTypesAccepted.push('application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation')
	}
	if (accept.includes('zip')) {
		fileTypesAccepted.push('application/zip', 'application/x-zip', 'application/x-zip-compressed', 'application/octet-stream', 'application/x-compress', 'application/x-compressed', 'multipart/x-zip')
	}
	if (accept.includes('gif')) {
		fileTypesAccepted.push('image/gif')
	}
	if (accept.includes('google-slides')) {
		fileTypesAccepted.push('application/vnd.google-apps.presentation')
	}
	//@todo: google docs
	//application/vnd.google-apps.document,application/vnd.google-apps.drawing,application/vnd.google-apps.presentation,application/vnd.google-apps.spreadsheet
	return fileTypesAccepted
}

function getDropboxFileTypesAccepted(accept) {
	const fileTypesAccepted = []
	if (accept.includes('image')) {
		fileTypesAccepted.push('.png', '.jpg', '.jpeg', '.pjpeg', '.gif', '.bmp', '.pdf')
	}
	if (accept.includes('audio')) {
		fileTypesAccepted.push('.mp3', '.ogg', '.m4a', '.wav', '.aiff', '.aif', '.ac3', '.aac', '.wma')
	}
	if (accept.includes('video')) {
		fileTypesAccepted.push('.mpg', '.mpeg', '.mp4', '.flv', '.mov', '.avi', '.mpeg-1', '.mpeg-2', '.qt', '.m4v', '.wmv', '.3gp', '.asf', '.ogv', '.3gpp', '.webm')
	}
	if (accept.includes('pdf')) {
		fileTypesAccepted.push('.pdf')
	}
	if (accept.includes('ppt')) {
		fileTypesAccepted.push('.ppt', '.pptx', '.odp', '.pptm')
	}
	if (accept.includes('zip')) {
		fileTypesAccepted.push('.zip')
	}
	if (accept.includes('gif')) {
		fileTypesAccepted.push('.gif')
	}
	return fileTypesAccepted
}

function getOneDriveFileTypesAccepted(accept) {
	let fileTypesAccepted = ''
	if (accept.includes('image')) {
		fileTypesAccepted += '.png,.jpg,.jpeg,.pjpeg,.gif,.bmp,.pdf'
	}
	if (accept.includes('audio')) {
		fileTypesAccepted += ',.mp3,.ogg,.m4a,.wav,.aiff,.aif,.ac3,.aac,.wma'
	}
	if (accept.includes('video')) {
		fileTypesAccepted += ',.mpg,.mpeg,.mp4,.flv,.mov,.avi,.mpeg-1,.mpeg-2,.qt,.m4v,.wmv,.3gp,.asf,.ogv,.3gpp,.webm'
	}
	if (accept.includes('pdf')) {
		fileTypesAccepted += ',.pdf'
	}
	if (accept.includes('ppt')) {
		fileTypesAccepted += ',.ppt,.pptx,.odp,.pptm'
	}
	if (accept.includes('zip')) {
		fileTypesAccepted += ',.zip'
	}
	if (accept.includes('gif')) {
		fileTypesAccepted += ',.gif'
	}
	return fileTypesAccepted
}

export {
	getLocalFileTypesAccepted,
	getDriveFileTypesAccepted,
	getDropboxFileTypesAccepted,
	getOneDriveFileTypesAccepted,
}
